import { useState } from 'react';
import { useInterval } from '../../../../utilities/hooks';
import { formatInTimeZone } from 'date-fns-tz';
import { POLLING_INTERVAL } from '../../../../utilities/constants';

function useClockTime() {
  const [clock, setClock] = useState(Date.now());
  useInterval(
    async () => {
      setClock(Date.now());
    },
    POLLING_INTERVAL.SECOND,
    true
  );

  return clock;
}

export function Clock({ timezone }) {
  const clock = useClockTime();
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  return `${formatInTimeZone(
    clock,
    tz,
    "EEE M'/'dd'/'yyyy @ hh:mm:ss aaa zzz"
  )}`;
}
